import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';
import { VehicleGroup } from './schemas/vehicle-group.schema';

export function putVehicleGroups(vehicleGroup: Partial<VehicleGroup>) {
  return fromFetch(
    new Request(
      fleetEnvironment.vehicleGroupsIdUrl(String(vehicleGroup.vehicleGroupId)),
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify(vehicleGroup),
      }
    )
  ).pipe(ignoreData());
}
